module.exports = __webpack_public_path__ + "img/Iherb.225b7961.png";